import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MicIcon, PlusIcon, SearchIcon, StarIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from '../components/Button';
import { useScreenInit } from '../useScreenInit';
export function ProductDetail() {
  useScreenInit();
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-col h-full bg-white overflow-y-auto pb-6" data-id="element-147">
      {/* Product Image Placeholder */}
      <div className="w-full h-64 bg-slate-100 flex items-center justify-center relative" data-id="element-148">
        <div className="w-32 h-32 bg-zinc-600 rounded-lg opacity-80 shadow-inner" data-id="element-149"></div>
        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-sm border border-slate-200" data-id="element-150">
          <CheckCircle2Icon size={16} className="text-green-600" data-id="element-151" />
          <span className="text-xs font-semibold text-slate-700" data-id="element-152">
            In Stock (42)
          </span>
        </div>
      </div>

      <div className="p-6" data-id="element-153">
        <div className="mb-6" data-id="element-154">
          <div className="flex justify-between items-start mb-2" data-id="element-155">
            <h1 className="text-2xl font-bold text-slate-900 leading-tight" data-id="element-156">
              3" Premium Deck Screws
            </h1>
            <span className="text-xl font-bold text-slate-900" data-id="element-157">$34.98</span>
          </div>
          <p className="text-sm text-slate-500 mb-3" data-id="element-158">
            5 lb. Box • Star Drive • Exterior Coated
          </p>

          <div className="flex items-center gap-1 text-amber-500 mb-4" data-id="element-159">
            <StarIcon size={16} fill="currentColor" data-id="element-160" />
            <StarIcon size={16} fill="currentColor" data-id="element-161" />
            <StarIcon size={16} fill="currentColor" data-id="element-162" />
            <StarIcon size={16} fill="currentColor" data-id="element-163" />
            <StarIcon size={16} className="text-slate-300" data-id="element-164" />
            <span className="text-xs text-slate-500 ml-1" data-id="element-165">(128 reviews)</span>
          </div>
        </div>

        <div className="space-y-3 mb-8" data-id="element-166">
          <Button icon={PlusIcon} onClick={() => navigate('/list')} data-id="element-167">
            Add to List
          </Button>
          <Button variant="secondary" icon={MicIcon} onClick={() => navigate('/chat')} data-id="element-168">
            Ask AI About This Product
          </Button>
          <Button variant="outline" icon={SearchIcon} data-id="element-169">
            Find Similar Products
          </Button>
        </div>

        <div className="space-y-6" data-id="element-170">
          <section data-id="element-171">
            <h3 className="text-base font-semibold text-slate-900 mb-2" data-id="element-172">
              Description
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-173">
              Premium exterior wood screws designed for decking and exterior
              wood-to-wood connections. Features a star drive head to prevent
              cam-out and a proprietary coating for superior rust resistance.
            </p>
          </section>

          <section data-id="element-174">
            <h3 className="text-base font-semibold text-slate-900 mb-2" data-id="element-175">
              Features
            </h3>
            <ul className="text-sm text-slate-600 space-y-2 list-disc pl-4" data-id="element-176">
              <li data-id="element-177">No pre-drilling required in most woods</li>
              <li data-id="element-178">Type 17 point for fast starts</li>
              <li data-id="element-179">Countersinking nibs for a clean finish</li>
              <li data-id="element-180">ACQ approved for treated lumber</li>
            </ul>
          </section>
        </div>
      </div>
    </motion.div>;
}